export default __webpack_public_path__ + "static/media/proibido-avancar.07805453.svg";